import { SessionCopyBackendCode } from '../components/ExamResultsRepository/ExamResultsRepository.types';

export interface ExamSession {
  id?: number;
  number?: string;
  name?: string;
  userEnteredSessionName?: string;
  sessionType?: string;
  year?: number;
  month?: number;
  oneId?: string;
  isTraining?: boolean;
}

export interface ExamScoreValue {
  sequence: number;
  score: number;
  oneExamScoringSchemaId: string;
  oneId: string;
}

export interface ExamScoringSchema {
  label: string;
  criterionName: string;
  criterionNumber: string;
  oneExamGradeRuleId: string;
  oneId: string;
  examScoreValues: ExamScoreValue[];
}

export interface ExamGradeRuleDto {
  missingAnswer: boolean;
  automaticScore: boolean;
  content: string;
  oneExamTaskId: string;
  oneId: string;
  examScoringSchema: ExamScoringSchema[];
}

export interface ExamTask {
  examTaskNumber: string;
  oneExamTaskGroupId: string;
  oneId: string;
  examGradeRuleDto: ExamGradeRuleDto;
}

export interface AssessmentSessionDto {
  oneExamTaskGroupId: string;
  oneId: string;
}

export interface ExamTaskGroup {
  name: string;
  examSheetId: number;
  oneExamSheetId: string;
  oneId: string;
  examTasks: ExamTask[];
  assessmentSessionDto: AssessmentSessionDto;
}

export interface ExamSheet {
  id: number;
  code: string;
  name: string;
  examId: number;
  oneExamId: string;
  oneId: string;
  examTaskGroups: ExamTaskGroup[];
  isSelected: boolean;
}

export interface SelectedExamSheet {
  id: number;
  code: string;
  name: string;
  isSelected?: boolean;
  customNumber: string;
  imported?: boolean;
}

export interface Exam {
  id: number;
  name: string;
  code: string;
  examSessionId: number;
  oneId: string;
  oneExamSessionId: string;
  examSheets: ExamSheet[];
  declarationTypeId: number;
  description?: string;
}

export interface ExamSheetType {
  id: number;
  name: string;
  code: string;
  examSheetTypeId: number;
  examId: number;
  isSelected?: boolean;
  customNumber: string;
}

export enum SourceSystemType {
  SIOEOE = 1,
  SIOEPKZ = 2,
  ONE_for_DEV = 3,
  OKE = 4,
}

export interface ExamSessionDto {
  sourceSystemType: SourceSystemType;
  examSession: ExamSession;
  exams: Exam[];
  examSheetTypes: ExamSheetType[];
}

export interface ImportedExamSession {
  id: number;
  number: number;
  name: string;
  idRequestType: number;
  dateBegin: string;
}

export interface ExamFromExternalSystem {
  id: number;
  name: string;
  code: string;
  declarationTypeId: number;
  customNumber: string;
  description: string;
}

export interface ExamFromExternalSystemWithExamSheets extends ExamFromExternalSystem {
  examSheets: SelectedExamSheet[] | null;
}

export interface CopyExamSheetDto {
  requestId: string;
  examSessionId: string | null;
  examSessionName: string;
  isTraining: boolean | null;
  examSessionType: string;
  year: number | null;
  month: number | null;
  examName: string;
  examCode: string;
}

export interface ExamSessionSimpleDto {
  id: string;
  name: string;
}

export interface CopyExamSheetResponse {
  sheetCode: string;
  copyExamSheetResponse: SessionCopyBackendCode;
  operationId: string | null;
  status: CopyExamSheetStatus | null;
}

export type CopyExamSheetStatus = 'Preparing' | 'Copying' | 'Stopping' | 'Cleaning' | 'Succeeded' | 'Failed';

export interface CopyExamSheetOperation {
  operationId: string;
  status: CopyExamSheetStatus;
  targetExamSheetId: string | null;
  targetExamId: string | null;
  targetExamSessionId: string | null;
  isNewExamSession: boolean;
  sourceExamSheetId: string;
  sourceSheetCode: string;
  targetSheetCode: string | null;
  updatedAt: string;
  finishedAt: string | null;
}
